import type { Transaction } from "@e308/core";
import type { SeatModel } from "./content-types.js";
import { formatMicro, type Micro, microFromString } from "./exact-numbers.js";
import {
  completeResearch,
  endResearch,
  researchCost,
  researchDurationMs,
  researchLegal,
  startResearch,
} from "./research-state.js";

export function runResearchStep(
  transaction: Transaction<Micro>,
  seats: readonly SeatModel[],
  stepMs: number,
): void {
  for (const seat of seats) settleSeatResearch(transaction, seat, stepMs);
}

function settleSeatResearch(
  transaction: Transaction<Micro>,
  seat: SeatModel,
  stepMs: number,
): void {
  let state = transaction.getRecord(seat.research);
  if (transaction.get(seat.resources.headquarters) <= 0n) {
    transaction.setRecord(seat.research, endResearch(state));
    return;
  }
  const completedThisStep = Boolean(
    state.active && transaction.gameTimeMs() >= state.active.completesAtMs,
  );
  if (completedThisStep) state = completeResearch(state);
  if (
    !completedThisStep &&
    !state.active &&
    state.queue[0] &&
    researchLegal(state, state.queue[0])
  ) {
    const cost = microFromString(String(researchCost(state, state.queue[0])));
    const stock = transaction.get(seat.resources.researchPoints);
    if (stock >= cost) {
      const rawDeadline = transaction.gameTimeMs() + researchDurationMs(state.queue[0]);
      const deadline = Math.ceil(rawDeadline / stepMs) * stepMs;
      transaction.set(seat.resources.researchPoints, (stock - cost) as Micro);
      state = startResearch(state, formatMicro(cost), deadline);
    }
  }
  transaction.setRecord(seat.research, state);
}
